import { Empty, Skeleton } from "antd";

export default function TopPerformingTeamLeaders({
  data,
  loading,
  rowKey = "teamLeaderId",
}) {
  return (
    <div className="border-2 border-light rounded-[10px] overflow-hidden">
      <h2 className="text-title font-semibold px-5 py-4 border-b border-light">
        Top Performing Team Leaders
      </h2>

      <div className="p-5 space-y-3">
        {loading ? (
          Array.from({ length: 3 }).map((_, idx) => (
            <div
              key={`leader-skeleton-${idx}`}
              className="border-2 border-light rounded-[10px] p-4"
            >
              <Skeleton active title={false} paragraph={{ rows: 2 }} />
            </div>
          ))
        ) : data?.length ? (
          data.map((item, idx) => (
            <div
              key={
                item?.[rowKey] ?? `${item?.teamLeadName || "team-lead"}-${idx}`
              }
              className="border border-light rounded-[10px] px-4 py-3 flex items-center justify-between gap-3"
            >
              <div className="flex items-center gap-3 min-w-0">
                <span className="h-10 w-10 shrink-0 rounded-full bg-secondaryBackground text-title font-semibold flex items-center justify-center text-sm">
                  #{idx + 1}
                </span>
                <div className="min-w-0">
                  <p className="font-semibold text-title text-base truncate">
                    {item?.teamLeaderName || item?.teamLeadName || "--"}
                  </p>
                  <p className="text-gray-500 text-sm truncate">
                    {item?.teamName || item?.officeName || "--"}
                  </p>
                </div>
              </div>

              <div className="text-right shrink-0">
                <p className="font-semibold text-title text-xl leading-tight">
                  ${Number(item?.totalDeposits || 0).toLocaleString("en-US")}
                </p>
                <p className="text-gray-500 text-sm">
                  conv{" "}
                  {Number(item?.conversionRatio || 0).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                  %
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="py-6">
            <Empty description="No team leaders found" />
          </div>
        )}
      </div>
    </div>
  );
}
